import {useSelector} from 'react-redux'

const edges = [
	[4,2],
	[2,0],
	[0,1],
	[1,3],
	[10,8],
	[8,6],
	[6,5],
	[6,12],
	[12,14],
	[12,11],
	[14,16],
	[5,7],
	[5,11],
	[11,13],
	[13,15],
	[7,9]
]

const Poses = ({threshold,scale,pointColor="#fff",lineColor="#fff"})=>{
	const poses = useSelector(state=>state.ai.poses)
	if(poses.length === 0) return null
	return ([
		poses.map(
			p => edges.map((e,ei)=>(
					(p.keypoints[e[0]].score>threshold&&p.keypoints[e[1]].score>threshold)&&
					<line 
						key={ei} 
						x1={p.keypoints[e[0]].x*scale} y1={p.keypoints[e[0]].y*scale}
						x2={p.keypoints[e[1]].x*scale} y2={p.keypoints[e[1]].y*scale}
						stroke={lineColor}
						strokeWidth={2}
					/>
				)//end edges map
			)//end p => 
		),//end poses map
		poses.map(
			p => p.keypoints.map(
				(kpt,kpti) => (
					kpt.score>threshold&&<circle key={kpti} cx={kpt.x*scale} cy={kpt.y*scale} r={2} fill={pointColor}/>
				)//end keypoints map
			)//end pi =>
		),//end poses map
	])
}

export default Poses